<template>
  <section>
    <template v-for="{ columns, type, subType } in tablesConfig">
      <DataTable
        v-if="
          filters[DerivativesFiltersTypes.Date].selected === type &&
          filters[DerivativesFiltersTypes.Type].selected === subType
        "
        :key="type"
        class="derivatives-table"
        :data-testid="`derivatives-table-${type}-${subType}`"
        :data="items"
        :items-per-page="itemsPerPage"
        :status="status"
        :columns="columns"
      >
        <template #empty>
          <HelperViewContextual
            class="derivatives-table__helper"
            icon="BB0040"
            description="Você não possui ativos no filtro selecionado"
          />
        </template>
      </DataTable>
    </template>
  </section>
</template>
<script lang="ts" setup>
import { computed } from 'vue';

import { DataTable, HelperViewContextual } from '@warrenbrasil/nebraska-web';
import {
  DerivativesFiltersDateValues,
  IDerivativesFilters,
  DerivativesFiltersTypes,
  DerivativesFiltersTypeValues
} from '../../types';
import { columns } from './columns';
import {
  ForwardContractPosition,
  OptionPosition
} from '@/modules/trade/services/instruments/types';

interface Props {
  filters: IDerivativesFilters;
  isLoading: boolean;
  itemsPerPage: number;
  items: ForwardContractPosition[] | OptionPosition[];
}
const props = defineProps<Props>();

const tablesConfig = computed(() => [
  {
    type: DerivativesFiltersDateValues.Today,
    subType: DerivativesFiltersTypeValues.Options,
    columns:
      columns[DerivativesFiltersDateValues.Today][
        DerivativesFiltersTypeValues.Options
      ]
  },
  {
    type: DerivativesFiltersDateValues.Historical,
    subType: DerivativesFiltersTypeValues.Options,
    columns:
      columns[DerivativesFiltersDateValues.Historical][
        DerivativesFiltersTypeValues.Options
      ]
  },
  {
    type: DerivativesFiltersDateValues.Today,
    subType: DerivativesFiltersTypeValues.Forwards,
    columns:
      columns[DerivativesFiltersDateValues.Today][
        DerivativesFiltersTypeValues.Forwards
      ]
  },
  {
    type: DerivativesFiltersDateValues.Historical,
    subType: DerivativesFiltersTypeValues.Forwards,
    columns:
      columns[DerivativesFiltersDateValues.Historical][
        DerivativesFiltersTypeValues.Forwards
      ]
  }
]);
const status = computed(() => (props.isLoading ? 'loading' : 'default'));
</script>

<style lang="less" scoped>
.derivatives-table {
  padding: @size-spacing-x500;
  border: @size-border-x400 solid @divider-primary;
  border-radius: @size-radius-x200;

  /deep/ th {
    white-space: nowrap;
  }

  /deep/ td:not(:first-child) {
    white-space: nowrap;
  }

  &__helper {
    padding: @size-spacing-x700 0 @size-spacing-x500 0;
    margin: 0 auto;
  }
}
</style>
